import { memo, CSSProperties, useMemo } from "react";
import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface FilePreviewErrorStateProps {
  title: string;
  message?: string;
  className?: string;
  isFullScreen?: boolean;
  maxWidth?: number;
  maxHeight?: number;
  style?: CSSProperties;
}

export const FilePreviewErrorState = memo(
  ({
    title,
    message,
    className,
    isFullScreen,
    maxWidth,
    maxHeight,
    style,
  }: FilePreviewErrorStateProps) => {
    const computedStyle = useMemo(() => {
      if (isFullScreen) return style;
      return {
        ...(maxWidth && { width: `${maxWidth}px` }),
        ...(maxHeight && { height: `${maxHeight}px` }),
        ...style,
      };
    }, [isFullScreen, maxWidth, maxHeight, style]);

    return (
      <div
        className={cn(
          "flex items-center justify-center bg-gray-100 rounded-lg p-8 w-full",
          { "h-full": isFullScreen },
          className,
        )}
        style={computedStyle}
      >
        <div className="text-center">
          <AlertCircle className="h-12 w-12 mx-auto mb-3 text-red-500" />
          <p className="text-gray-700 font-medium">{title}</p>
          {message && <p className="text-sm text-gray-600 mt-2">{message}</p>}
        </div>
      </div>
    );
  },
);
